(() => {
  'use strict';

  const VERSION = '2026-09-10-mobile-shell-v34';
  const MOBILE = '(max-width: 989px)';
  if (window.__ddMobileShellFixVersion === VERSION) return;
  window.__ddMobileShellFixVersion = VERSION;

  let raf = 0;
  let observer = null;

  function visibleInViewport(node) {
    if (!(node instanceof Element) || node.hidden) return false;
    const style = window.getComputedStyle(node);
    if (style.display === 'none' || style.visibility === 'hidden' || Number(style.opacity || 1) === 0) return false;
    const rect = node.getBoundingClientRect();
    return rect.width > 2 && rect.height > 2 && rect.right > 0 && rect.left < window.innerWidth && rect.bottom > 0 && rect.top < window.innerHeight;
  }

  function explicitlyOpen(node) {
    if (!(node instanceof Element) || node.hidden) return false;
    return node.classList.contains('is-open') ||
      node.classList.contains('is-active') ||
      node.classList.contains('open') ||
      node.getAttribute('data-open') === 'true' ||
      node.getAttribute('data-state') === 'open';
  }

  function isOpen(node) {
    return explicitlyOpen(node) || visibleInViewport(node);
  }

  function resetPanelAccessibility(node) {
    if (!(node instanceof HTMLElement)) return;
    node.removeAttribute('aria-hidden');
    if ('inert' in node) node.inert = false;
  }

  function syncPanelAccessibility(node, open) {
    if (!(node instanceof HTMLElement)) return;
    if (!window.matchMedia(MOBILE).matches) {
      resetPanelAccessibility(node);
      return;
    }
    node.setAttribute('aria-hidden', open ? 'false' : 'true');
    if ('inert' in node) node.inert = !open;
  }

  function removeSocialUi(section) {
    if (!(section instanceof Element)) return;
    section.querySelectorAll('.dd-mobile-social-dock, .ddmm22__social, .ddmm27__social').forEach(node => node.remove());
  }

  function sync() {
    const body = document.body;
    if (!body) return;

    const section = document.querySelector('.faire-dawn-header-section');

    if (!window.matchMedia(MOBILE).matches) {
      body.classList.remove('dd-mobile-menu-open', 'dd-mobile-cart-open', 'dd-mobile-account-open');
      if (section) {
        [
          section.querySelector('.faire-site-header__drawer, [data-faire-mobile-drawer]'),
          section.querySelector('.faire-site-header__dropdown--cart, [data-faire-dropdown="cart"]'),
          section.querySelector('.faire-site-header__dropdown--account, [data-faire-dropdown="account"]')
        ].forEach(resetPanelAccessibility);
      }
      return;
    }

    if (!section) return;
    removeSocialUi(section);

    const drawer = section.querySelector('.faire-site-header__drawer, [data-faire-mobile-drawer]');
    const cart = section.querySelector('.faire-site-header__dropdown--cart, [data-faire-dropdown="cart"]');
    const account = section.querySelector('.faire-site-header__dropdown--account, [data-faire-dropdown="account"]');

    const cartOpen = isOpen(cart);
    const accountOpen = isOpen(account);
    const menuOpen = isOpen(drawer) && !cartOpen && !accountOpen;

    syncPanelAccessibility(drawer, menuOpen);
    syncPanelAccessibility(cart, cartOpen);
    syncPanelAccessibility(account, accountOpen);

    body.classList.toggle('dd-mobile-menu-open', menuOpen);
    body.classList.toggle('dd-mobile-cart-open', cartOpen);
    body.classList.toggle('dd-mobile-account-open', accountOpen);
  }

  function queue() {
    if (raf) return;
    raf = requestAnimationFrame(() => {
      raf = 0;
      sync();
    });
  }

  function start() {
    queue();
    observer = new MutationObserver(queue);
    observer.observe(document.documentElement, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ['class', 'style', 'hidden', 'aria-hidden', 'aria-expanded', 'data-open', 'data-state']
    });
    document.addEventListener('click', () => {
      queue();
      setTimeout(queue, 60);
      setTimeout(queue, 180);
    }, true);
    document.addEventListener('shopify:section:load', queue);
    document.addEventListener('shopify:section:reorder', queue);
    window.addEventListener('resize', queue, { passive: true });
    window.addEventListener('orientationchange', queue, { passive: true });
    setTimeout(queue, 120);
    setTimeout(queue, 420);
  }

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', start, { once: true })
    : start();
})();
